<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <LoginToken />
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import LoginToken from '@/components/login/token'

export default {
  name: 'view-login-token',
  components: { LoginToken }
}
</script>

<style scoped>
</style>
